import { Link } from "react-router-dom";
import { formatLabel } from "@/lib/api";
import { Calendar, FileText, MapPin } from "lucide-react";

const IMPACT_COLORS = {
  restricts: "bg-[#D32F2F] text-white",
  protects: "bg-[#008A00] text-white",
  mixed: "bg-[#0050FF] text-white",
};

const STATUS_COLORS = {
  proposed: "bg-white text-[#5a4a00] border-yellow-700",
  passed: "bg-white text-[#005a00] border-[#008A00]",
  blocked: "bg-white text-[#7a3500] border-orange-700",
  signed: "bg-white text-[#0040cc] border-[#0050FF]",
  vetoed: "bg-white text-[#8a1a1a] border-red-700",
  enforced: "bg-white text-[#8a1a1a] border-[#D32F2F]",
  repealed: "bg-white text-[#222] border-gray-700",
  court_ruling: "bg-white text-[#4a1f7a] border-purple-700",
  executive_action: "bg-white text-[#1f2a8a] border-indigo-700",
};

export default function EntryCard({ entry, dense = false }) {
  return (
    <Link
      to={`/entry/${entry.id}`}
      data-testid={`entry-card-${entry.id}`}
      className="group block bg-white border border-black/15 hover:border-black/60 transition-all duration-150 hover:-translate-y-1"
    >
      <div className="p-5 md:p-6">
        <div className="flex items-center gap-2 flex-wrap mb-3">
          <span className={`text-xs font-mono-plex uppercase tracking-wider px-2 py-1 ${IMPACT_COLORS[entry.impact] || ""}`}>
            {formatLabel(entry.impact)}
          </span>
          <span className={`text-xs font-mono-plex uppercase tracking-wider px-2 py-1 border ${STATUS_COLORS[entry.status] || ""}`}>
            {formatLabel(entry.status)}
          </span>
          <span className="text-xs font-mono-plex uppercase tracking-wider text-[#555]">
            {formatLabel(entry.category)}
          </span>
        </div>
        <h3 className={`font-display ${dense ? "text-xl" : "text-2xl"} font-bold tracking-tight leading-tight group-hover:underline decoration-2 underline-offset-4`}>
          {entry.title}
        </h3>
        <p className="text-sm text-[#333] mt-3 leading-relaxed line-clamp-3">{entry.summary}</p>
        <div className="mt-4 flex items-center flex-wrap gap-x-5 gap-y-2 text-xs font-mono-plex text-[#555] uppercase tracking-wider">
          <span className="inline-flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" />{entry.date_action}</span>
          <span className="inline-flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" />{entry.jurisdiction}</span>
          <span className="inline-flex items-center gap-1.5"><FileText className="w-3.5 h-3.5" />{entry.citations?.length || 0} {(entry.citations?.length || 0) === 1 ? "Receipt" : "Receipts"}</span>
        </div>
      </div>
    </Link>
  );
}
